import api from './api';
import { IUserList, IUserTreeNode } from '../types/userList';

export const userListService = {
  getLists: async (): Promise<IUserList[]> => {
    const response = await api.get<IUserList[]>('/user-lists');
    return response.data;
  },
  createList: async (payload: { title: string; description?: string }): Promise<IUserList> => {
    const response = await api.post<IUserList>('/user-lists', payload);
    return response.data;
  },
  getNodes: async (listId: string): Promise<IUserTreeNode[]> => {
    const response = await api.get<IUserTreeNode[]>(`/user-lists/${listId}/nodes`);
    return response.data;
  },
  createNode: async (
    listId: string,
    payload: {
      fullName: string;
      email: string;
      mobileNumber: string;
      parentId?: string | null;
      dependencyRole?: 'primary' | 'secondary' | 'third' | 'fourth' | 'fifth' | null;
    }
  ): Promise<IUserTreeNode> => {
    const response = await api.post<IUserTreeNode>(`/user-lists/${listId}/nodes`, payload);
    return response.data;
  },
  updateNode: async (
    listId: string,
    nodeId: string,
    payload: {
      fullName?: string;
      email?: string;
      mobileNumber?: string;
      parentId?: string | null;
      dependencyRole?: 'primary' | 'secondary' | 'third' | 'fourth' | 'fifth' | null;
    }
  ): Promise<IUserTreeNode> => {
    const response = await api.patch<IUserTreeNode>(`/user-lists/${listId}/nodes/${nodeId}`, payload);
    return response.data;
  },
  deleteNode: async (listId: string, nodeId: string): Promise<void> => {
    await api.delete(`/user-lists/${listId}/nodes/${nodeId}`);
  }
};
